import React, { Component } from 'react';
import logo from './logo.js';
import './App.css';
import Treemap from './components/Treemap';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="App-logo-Container">{logo}</div>
          <h1 className="App-title">This is an Example Embed</h1>
        </header>
        <div className="Treemap-wrapper">
          <Treemap />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js